import { Component, OnInit, Input } from '@angular/core';
import { PlanAttributes, SummaryView } from '../../interfaces/plan-attributes.interface';
import { BooleanInput, PtlWindowLocationService } from '@ptl/global-components';
import { Product } from '../../interfaces/product.interface';
import { ReducerUtilityService } from '@ptl/state';
import { ENROLLMENT_FLOW } from 'src/app/angular-elements/form-wrappers/plan-enrollment/individual-plan-enrollment-form/configs/interfaces/enrollment-flow.enum';

@Component({
    selector: 'app-plan-details-header',
    templateUrl: './plan-details-header.component.html',
    styleUrls: ['./plan-details-header.component.scss'],
    standalone: false
})
export class PlanDetailsHeaderComponent implements OnInit {

  @Input() planData: Product<PlanAttributes, SummaryView>;
  @Input() enrollStartUrl: string;
  @Input() specialEnrollmentUrl: string;
  @Input() viewPlansUrl: string;
  @Input() recommendedPlansUrl: string;
  @Input() sendReferralUrl: string;
  @Input() @BooleanInput() showSaveQuoteButton: boolean;
  @Input() @BooleanInput() enableNewPrintExperience: boolean;
  @Input() saveQuoteText: string;
  @Input() returnUrl: string;
  @Input() enrollmentFlow: string;
  @Input() quoteButtonPage: string;

  isSep: boolean;

  currentTab: string;
  
  constructor(
    private windowLocationService: PtlWindowLocationService,
    private reducerUtilityService: ReducerUtilityService
  ) { }

  ngOnInit() {
    this.isSep = this.enrollmentFlow === ENROLLMENT_FLOW.SEP_PAPER || this.enrollmentFlow === ENROLLMENT_FLOW.SEP_ELECTRONIC ? true : false;
    this.currentTab = this.reducerUtilityService.getComponentStates().PlanDetailsActiveTab.activeTab;
  }

  goToSendReferral() {
    this.windowLocationService.goToUrl(this.sendReferralUrl);
  }

}
